module.exports = __webpack_public_path__ + "logo-white-splash.ac98d65dd3f565db726c.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/theme/images/logo-white-splash.svg
// module id = ../../../../../resources/theme/images/logo-white-splash.svg
// module chunks = styles